<template>
  <div class="page" style="padding:10px;" contenteditable>
    <div class="m-2 d-print-none text-center">
      <b-btn-group class="mr-4">
        <b-btn variant="primary" :disabled="!official" @click="setOfficial(false)">
          Nieoficjalny
        </b-btn>

        <b-btn :disabled="official" @click="setOfficial(true)">
          Oficjalny
        </b-btn>
      </b-btn-group>

      <b-btn-group>
        <b-btn @click="changeMonth(-1)">
          <i class="fa fa-fw fa-arrow-left"></i>
        </b-btn>

        <b-btn>{{ monthName[month - 1] }}</b-btn>

        <b-btn @click="changeMonth(1)">
          <i class="fa fa-fw fa-arrow-right"></i>
        </b-btn>
      </b-btn-group>
    </div>

    <table class="w-100 head" style="margin-top:5px;">
      <tr>
        <td rowspan="4" style="width:25%;" class="border">
          <h6>Miesięczna ewidencja czasu pracy</h6>

          <h6>Rok {{ year }}</h6>

          <h6>Miesiąc {{ month }}</h6>
        </td>

        <td class="text-center border" style="width:30%;">
          <h6>Nazwa firmy</h6>
        </td>
        
        <td class="border text-center">
          <h6>Komórka organizacyjna</h6>
        </td>
        
        <td class="border text-center">
          <h6>Stanowisko</h6>
        </td>
      </tr>
      
      <tr class="text-center">
        <td class="text-center border" style="width:30%;">{{ companyName }}</td>
      
        <td class="border">{{ companyName }}</td>
      
        <td class="border"></td>
      </tr>
      
      <tr class="text-center">
        <td class="text-center border" style="width:30%;">
          <h6>Imię i nazwisko pracownika</h6>
        </td>
      
        <td class="border">
          <h6>Miesięczna norma czasy pracy</h6>
        </td>
      
        <td class="border">
          <h6>Numer ewidencyjny pracownika</h6>
        </td>
      </tr>
      
      <tr class="text-center">
        <td class="text-center border" style="width:30%;">{{ employeeName }}</td>
      
        <td class="border">
          <h6 class="d-inline pr-3">Dni</h6>
      
          <span v-if="timetable.length > 0">{{ timetableDays }}</span>
      
          <h6 class="d-inline px-3">Godziny</h6>

          <span v-if="timetable.length > 0">{{ convertFromMinutesToHHMM(timetableTotal) }}</span>
        </td>
      
        <td class="border">{{ employeeId }}</td>
      </tr>
    </table>
    
    <table style="width:100%;" class="border text-center">
      <thead>
        <tr>
          <th class="border bg-gray">Dzień miesiąca</th>
    
          <th class="border bg-gray">Dzień tygodnia</th>
    
          <th class="border bg-gray">Kategoria dnia</th>
    
          <th class="border bg-gray">Normatywny dzień pracy</th>
    
          <th class="border bg-gray">Faktyczny czas pracy</th>
    
          <th class="border bg-gray">Godziny nadliczbowe</th>
    
          <th class="border bg-gray" v-for="absence of absences" :key="absence.id">{{ absence.code }}</th>
    
          <th class="border bg-gray">Suma</th>
    
          <th class="border bg-gray" style="min-width:7vw;">Uwagi</th>
        </tr>
      </thead>
    
      <tbody>
        <tr v-for="index in numberOfDaysInMonth" :key="index">
          <td class="border bg-gray">{{ index }}</td>
    
          <td class="border bg-gray">{{ shortDayName(index) }}</td>
    
          <td class="border">{{ holidays[index] }}</td>
    
          <td class="border">{{ holidays[index] !== 'UDW' && timetable[index] ? convertFromMinutesToHHMM(timetable[index]) : ' ' }}</td>
    
          <td class="border">{{ (official && workTime[index]) ? convertFromMinutesToWorkHours(workTime[index] + partialDayOff(index)) : convertFromMinutesToHHMM(workTime[index]) }}</td>
    
          <td class="border">{{ convertFromMinutesToHHMM(overtime[index]) }}</td>
    
          <td v-for="absence of absences" :key="absence.id" class="border">
            <span>{{ dayOffs[absence.id] ? convertFromMinutesToHHMM(dayOffs[absence.id][index]) : '' }}</span>
          </td>
    
          <td class="border">{{ convertFromMinutesToHHMM(total[index]) }}</td>
    
          <td class="border">{{ warnings[index] ? warnings[index].text : '' }}</td>
        </tr>
      </tbody>
    
      <tfoot class="thick-border">
        <tr>
          <td class="border bg-gray" rowspan="2">Suma</td>
    
          <td class="border bg-gray">Godziny</td>
    
          <td class="border"></td>
    
          <td v-if="timetable.length > 0" class="border">{{ convertFromMinutesToHHMM(timetableTotal) }}</td>
    
          <td class="border">{{ convertFromMinutesToHHMM(totalWorkdayHours) }}</td>
    
          <td class="border">{{ overtime.length ? convertFromMinutesToHHMM(overtimeTotal) : '' }}</td>
    
          <td class="border" v-for="absence of absences" :key="absence.id">
            <span>
              {{ dayOffs[absence.id] ? convertFromMinutesToHHMM(dayOffs[absence.id].reduce((prev, next) => (prev > 0 ? prev : 0) + (next > 0 ? next : 0), 0)) : '' }}
            </span>
          </td>
    
          <td class="border">{{ convertFromMinutesToHHMM(totalOfTotals) }}</td>
    
          <td class="border"></td>
        </tr>
    
        <tr>
          <td class="border bg-gray">Dni</td>
    
          <td class="border"></td>
    
          <td class="border">{{ timetable | tryToReduceToQuantity }}</td>
    
          <td class="border">{{ workTime | tryToReduceToQuantity }}</td>
    
          <td class="border">{{ overtime | tryToReduceToQuantity }}</td>
    
          <td v-for="absence of absences" :key="absence.id" class="border">{{ dayOffs[absence.id] | tryToReduceToQuantity }}</td>
    
          <td class="border">{{ total | tryToReduceToQuantity }}</td>
    
          <td class="border"></td>
        </tr>
      </tfoot>
    </table>
    
    <span class="legend">
      <span class="font-italic mx-3 my-0 d-inline-block" v-for="(value, key) in codes" :key="key">{{ key }} - {{ value }}</span>
    </span>
  </div>
</template>

<script>
import moment from 'moment';

import { TimesheetResource } from '@/resources/timesheet.resource';
import { TypeOfDay } from './TypeofDay.enum';

export default {
  data() {
    return {
      year: null,
      month: null,
      companyName: null,
      employeeName: null,
      workingTimeDaily: null,
      employeeId: null,
      numberOfDaysInMonth: 31,
      monthName: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień'
      ],
      weekdayName: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Ndz'],
      overtime: [],
      weekdayArray: [],
      timetable: [],
      workTime: [],
      dayOffs: {},
      count: {},
      absences: [],
      total: [],
      warnings: [],
      holidays: [],
      firstDayNameIndex: null,
      numberOfWorkDays: 0,
      totalWorkdayHours: 0,
      numberOfMinutesToStartOvertime: 30, // Ustawienia z bazy danych,
      maxOvertimeHoursPerDay: 2,
      maxTotalOvertime: 0,
      realTotal: 0,
      codes: {
        UDW: 'Dzień ustawowo wolny',
        P: 'Dzień pracujący',
        DW: 'Dzień wolny w harmonogramie pracownika'
      },
      night: { start: 1320, end: 300 },
      official: this.$route.query.official === 'true'
    };
  },
  computed: {
    // Całkowity czas nadgodzin
    overtimeTotal() {
      return this.overtime.reduce((x, y) => x + y, 0);
    },
    // Liczba dni normatywnych
    timetableDays() {
      return this.timetable.map(item => (item === null ? 0 : 1)).reduce((prev, next) => prev + next, 0);
    },
    // Całkowita liczba godzin normatywnych
    timetableTotal() {
      return this.timetable.reduce((prev, next) => prev + next, 0);
    },
    // Suma kolumny "Suma"
    totalOfTotals() {
      return this.total.reduce((prev, next) => prev + next, 0);
    }
  },
  methods: {
    // Zwraca nazwę dnia tygodnia
    shortDayName(index) {
      this.weekdayArray[index - 1] = (index + this.firstDayNameIndex - 1) % 7;
      return this.weekdayName[(index + this.firstDayNameIndex - 1) % 7];
    },

    // Formatuje czas na format hh:MM
    convertFromMinutesToHHMM(min) {
      if (!min) {
        return ' ';
      }
      if (min < 0) {
        min = 0;
      }
      const minutes = parseInt(min, 10);
      const h = '' + Math.floor(minutes / 60);
      const m = '' + (minutes % 60);
      return h.padStart(2, '0') + ':' + m.padStart(2, '0');
    },

    // Formatuje czas na format 8-(8+X)
    convertFromMinutesToWorkHours(minutes) {
      if (!minutes || minutes < 0) {
        return ' ';
      }
      if (minutes < 0) {
        minutes = 0;
      }
      minutes = parseInt(minutes, 10);
      const endHour = 8 + Math.floor(minutes / 60);
      const minutesLeft = (minutes % 60).toString().padStart(2, '0');
      return `8:00-${endHour}:${minutesLeft}`;
    },

    // Ustawia następny/poprzedni miesiąc
    changeMonth(num) {
      this.month += num;
      if (this.month === 0) {
        this.month = 12;
        this.year += -1;
      }
      if (this.month === 13) {
        this.month = 1;
        this.year += 1;
      }
      this.$router.push(
        {
          query: {
            year: this.year,
            month: this.month,
            id: this.$route.query.id,
            official: this.official
          }
        },
        () => this.$router.go()
      );
    },

    // Ustawia oficjalne/nieoficjalne podsumowanie
    setOfficial(official) {
      this.$router.push({ query: { ...this.$route.query, official } }, () => this.$router.go());
    },

    // Pobiera dane
    getData() {
      TimesheetResource.getData(this.employeeId, this.month, this.year)
        .then(data => this.convertRecivedData(data))
        .catch(error => console.warn(error));
    },

    // Mapuje dane na format przyjazny dla tabeli
    convertRecivedData(data) {
      this.employeeName = data.user.firstName + ' ' + data.user.lastName;
      this.companyName = data.user.card[0].company.name;
      this.absences = data.absence;
      this.absences.filter(absence => !(absence && absence.displayAsWorktime)).forEach(item => {
        this.codes[item.code] = item.name;
      });
      data.dayoffs.sort((dayOffA, dayOffB) => {
        if (!dayOffA.absence || !dayOffB.absence) {
          return 0;
        }
        if (dayOffA.absence.displayAsWorktime === dayOffB.absence.displayAsWorktime) {
          return 0;
        }
        if (dayOffA.absence.displayAsWorktime) {
          return 1;
        }
        return -1;
      });
      this.maxTotalOvertime = data.workdays
        .map(workday => workday.overtimeLimit || 0)
        .reduce((total, current) => total + current, 0);
      this.setDate();
      this.convertTimetable(data.user.timetables);
      this.convertHolidays(data.holidays);
      this.convertDayOffs(data.dayoffs);
      this.convertWorkdays(data.workdays);
      if (this.official) {
        this.calculateOvertime();
        this.calculateTotal();
      } else {
        this.calculateTotal();
        this.calculateOvertime();
      }
    },

    // Wylicza elementy powiązane z datą
    setDate() {
      const today = moment().set('date', 1);
      if (this.$route.query.year) {
        today.set('year', this.$route.query.year);
      }
      if (this.$route.query.month) {
        today.set('month', this.$route.query.month).subtract(1, 'month');
      }

      this.year = parseInt(today.format('YYYY'));
      this.month = parseInt(today.format('MM'));
      this.firstDayNameIndex = today.format('d') - 1;
      today.add(1, 'month');
      today.add(-1, 'day');
      this.numberOfDaysInMonth = parseInt(today.format('DD'), 10);
    },

    // Wylicza normatywny czas pracy
    convertTimetable(timetables) {
      const weekTimetable = ['monTime', 'tueTime', 'wedTime', 'thuTime', 'friTime', 'satTime', 'sunTime'];
      for (let i = 1; i <= this.numberOfDaysInMonth; i++) {
        for (const timetable of timetables) {
          const start = new Date(timetable.startDate).setHours(0, 0, 0, 0);
          const end = new Date(timetable.endDate).setHours(0, 0, 0, 0);
          const day = new Date(this.year, this.month - 1, i).setHours(0, 0, 0, 0);
          if (start <= day && (day <= end || timetable.endDate === null)) {
            this.timetable[i] = timetable.timetable[weekTimetable[this.weekdayArray[i - 1]]];
          }
        }
      }
    },

    // Wylicza faktyczny czas pracy
    convertWorkdays(workdays) {
      workdays.forEach(item => {
        const day = parseInt(moment(item.date).format('DD'));
        if (!item.start || !item.end) {
          return;
        }

        const worktime = item.end - item.start;
        this.realTotal += worktime;

        if (this.official || this.isFullDayOff(day)) {
          return;
        }

        this.calculateNight(item);
        this.totalWorkdayHours += worktime;
        this.workTime[day] = this.workTime[day] ? this.workTime[day] + worktime : worktime;
      });

      if (this.official) {
        let totalWorktime = this.realTotal;
        this.timetable.forEach((timetableHours, day) => {
          if (day === 0) {
            return;
          }
          const timetableDate = moment(
            `${this.year}-${this.month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
          );
          if (
            (this.workTime[day] && this.workTime[day] >= this.timetable[day]) ||
            !totalWorktime ||
            this.isFullDayOff(day) ||
            moment().isBefore(timetableDate)
          ) {
            return;
          }
          const leftToWork = this.workTime[day] ? timetableHours - this.workTime[day] : timetableHours;
          this.workTime[day] = Math.min(timetableHours - this.partialDayOff(day), totalWorktime);
          this.totalWorkdayHours += leftToWork;
          totalWorktime -= leftToWork;
        });
      }
    },

    // Wylicza uwagi dotyczące pracy nocnej
    calculateNight(workday) {
      const day = parseInt(moment(workday.date).format('DD'), 10);
      let nightTime = 0;
      if (workday.end > this.night.start) {
        nightTime += workday.start > this.night.start ? workday.end - workday.start : workday.end - this.night.start;
      }
      if (workday.start < this.night.end) {
        nightTime += workday.end < this.night.end ? workday.end - workday.start : this.night.end - workday.start;
      }
      if (nightTime) {
        if (!this.warnings[day]) {
          this.warnings[day] = {};
        }
        this.warnings[day].text = 'Praca nocna ' + this.convertFromMinutesToHHMM(nightTime);
        this.warnings[day].value = nightTime;
      }
    },

    // Wylicza święta i weekendy
    convertHolidays(holidays) {
      for (let i = 1; i <= this.numberOfDaysInMonth; i++) {
        if (this.timetable[i]) {
          this.holidays[i] = TypeOfDay.WORKDAY;
        } else {
          this.holidays[i] = TypeOfDay.REST_DAY;
        }
      }
      holidays.forEach(item => {
        const day = parseInt(moment(item.date).format('DD'), 10);
        this.holidays[day] = TypeOfDay.PUBLIC_HOLIDAY;
      });
      for (let i = 0; i < this.holidays.length; i++) {
        if (this.holidays[i] !== TypeOfDay.WORKDAY) {
          this.timetable[i] = null;
        }
      }
    },

    // Wylicza dni wolne
    convertDayOffs(array) {
      array.forEach(dayOff => {
        if (!dayOff.absence) {
          return;
        }
        if (!dayOff.absence.isPaid && !dayOff.absence.displayAsWorktime) {
          return;
        }
        dayOff.items.forEach(item => {
          if (this.month !== parseInt(moment(item.date).format('MM'))) {
            return;
          }

          const date = parseInt(moment(item.date).format('D'));

          let day = this.timetable[date];

          const isWeekend = !!day;

          if (!day && dayOff.absence && dayOff.absence.isWorktime) {
            day = this.findClosestWorkday(date);
          }

          if (!day) {
            return;
          }

          if (dayOff.hourStart && dayOff.hourEnd) {
            day = dayOff.hourEnd * 60 + dayOff.minuteEnd - (dayOff.hourStart * 60 + dayOff.minuteStart);
          }

          if (!isWeekend) {
            this.realTotal += day;
          }

          if (dayOff.absence && dayOff.absence.displayAsWorktime) {
            if (!this.workTime[date] && !this.isFullDayOff(date)) {
              this.workTime[date] = day;
            }
            this.totalWorkdayHours += day;
            if (!this.official) {
              this.warnings[date] = { text: `${dayOff.absence.code} (${this.convertFromMinutesToHHMM(day)})` };
            }
            return;
          }
          if (!dayOff.absence) {
            return;
          }

          if (!this.dayOffs[dayOff.absence.id]) {
            this.dayOffs[dayOff.absence.id] = [];
          }

          this.dayOffs[dayOff.absence.id][date] = day;
        });
      });

      this.absences = this.absences.filter(item =>
        Object.keys(this.dayOffs).some(used => parseInt(used) === parseInt(item.id))
      );
    },

    // Znajduje najbliższy dzień roboczy
    findClosestWorkday(date) {
      let day;
      let previousDate = date - 1;
      let nextDate = date + 1;
      while (!day && previousDate > 0 && nextDate <= 31) {
        day = this.timetable[previousDate] || this.timetable[nextDate];
        previousDate--;
        nextDate++;
      }
      return day;
    },

    // Wylicza sumy
    calculateTotal() {
      const dayoffs = this.sumDayOffs();
      for (let i = 1; i <= this.numberOfDaysInMonth; i++) {
        this.$set(this.total, i, this.calculateTotalRow(this.workTime[i], dayoffs[i], this.overtime[i]));
        if (
          this.shortDayName(i) === 'Ndz' &&
          ((this.workTime[i] && this.workTime[i] > 0) || (this.overtime[i] && this.overtime[i] > 0))
        ) {
          if (!this.warnings[i]) {
            this.warnings[i] = {};
          }
          this.warnings[i].text = 'Praca w niedzielę ' + this.convertFromMinutesToHHMM(this.total[i]);
          this.warnings[i].value = this.total[i];
        }
      }
    },

    // Wylicza pojedynczą sumę
    calculateTotalRow(workTime, dayOff, overtime) {
      let totalRow = 0;
      if (workTime) {
        totalRow += workTime;
      }
      if (dayOff) {
        totalRow += dayOff;
      }
      if (overtime) {
        totalRow += overtime;
      }

      return totalRow;
    },

    // Wylicza nadgodziny
    calculateOvertime() {
      if (this.official && !this.maxTotalOvertime) {
        return;
      }
      const maxOvertimeMinutes = this.official ? this.maxOvertimeHoursPerDay * 60 : 600;
      let overtime = this.official
        ? Math.min(this.realTotal - this.timetableTotal, this.maxTotalOvertime)
        : this.totalOfTotals - this.timetableTotal;
      let day = 0;
      while (overtime >= 0 && day <= this.numberOfDaysInMonth) {
        const weekday = (day + this.firstDayNameIndex - 1) % 7;
        if (this.workTime[day] && (!this.overtime || weekday !== 4)) {
          this.overtime[day] = Math.min(overtime, maxOvertimeMinutes);
          overtime -= this.overtime[day];
        }
        day++;
      }
    },

    // Wylicza całkowity czas dni wolnych
    sumDayOffs() {
      const keys = Object.keys(this.dayOffs).filter(key => parseInt(key, 10));
      const sumOfDayOffs = [];
      keys.forEach(key => {
        for (let i = 1; i <= this.numberOfDaysInMonth; i++) {
          const dayoff = this.dayOffs[key][i];
          if (dayoff && dayoff > 0) {
            sumOfDayOffs[i] = sumOfDayOffs[i] ? sumOfDayOffs[i] + dayoff : dayoff;
          }
        }
      });
      return sumOfDayOffs;
    },

    // Czy dzień jest dniem urlopowym
    isFullDayOff(day) {
      return Object.values(this.dayOffs).some(dayOffType => dayOffType[day] === this.timetable[day]);
    },

    // Niepełny dzień urlopowy
    partialDayOff(day) {
      return Object.values(this.dayOffs)
        .map(dayOffType => dayOffType[day] || 0)
        .reduce((total, current) => total + current, 0);
    }
  },
  created() {
    this.setDate();
    this.employeeId = parseInt(this.$route.params.id, 10);
    this.getData();
  },
  filters: {
    tryToReduceToQuantity(data) {
      if (data && data.length) {
        return data.map(item => (!!item && item > 0 ? 1 : 0)).reduce((prev, next) => prev + next, 0);
      }
      return ' ';
    }
  }
};
</script>
<style scoped>
.page {
  font-size: 1em;
}
@media print {
  .page {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    transform: rotate(90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
    width: 297mm;
    height: 210mm;
    position: fixed;
    top: 9cm;
    left: 2cm;
  }
}
.head h6,
.head {
  line-height: 1em;
}
.head td {
  padding: 4px 10px;
}
.border {
  border-width: 1px !important;
  border-color: black !important;
}
.bg-gray {
  background-color: #ccc;
}
h6 {
  margin: 0;
}
[class*=' col-'] {
  padding: 5px;
}
th {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border: none !important;
  font-size: 0.8em;
}
table {
  margin: 0;
}
thead td {
  font-size: 0.8em;
  padding: 0 10px;
}
td {
  font-size: 0.9em;
  border-width: 1px !important;
  border-color: black !important;
}
.thick-border {
  border-top: 3px solid black;
}
.legend {
  display: flex;
  flex-wrap: wrap;
  font-size: 10px;
}
</style>
